
  <img
    class="amplify-image"
    (click)="onImageClicked()"
    src="{{url}}"
  />



// WEBPACK FOOTER //
// ./node_modules/aws-amplify-angular/dist/src/components/storage/s3-image-component/s3-image.component.core.d.ts.S3ImageComponentCore.html